import React, { useState } from "react";
import { Container, Row, Col, Form, Image } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

const QRPHDoorHangerDetails = ({ navigation }) => {
  const [qrph_door_hanger_location, setLocation] = useState("");
  const [qrph_door_hanger_brand, setBranding] = useState("");
  const [qrph_door_hanger_count, setCount] = useState("");
  const [errors, setErrors] = useState({});

  const handleBack = () => {
     navigation.previous();
  };

  const validate = () => {
    const newErrors = {
      qrph_door_hanger_location: !qrph_door_hanger_location,
      qrph_door_hanger_brand: !qrph_door_hanger_brand,
      qrph_door_hanger_count: !String(qrph_door_hanger_count).trim(),
    };
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please complete required fields", { autoClose: 2500, hideProgressBar: true, theme: 'colored' });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (!validate()) return;
    try {
    localStorage.setItem('qrph-sticker-origin', 'qrph-details');
    } catch (e) {
      // ignore storage errors
    }
    if (navigation && navigation.go) navigation.go('qrph-door-sticker-merch');
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">QRPH Door Hanger Details</h4>
              <p className="form-desc">Provide details for the visible QRPH door hanger.</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* <h5 className="mb-3">QRPH DOOR HANGER DETAILS</h5> */}

      {/* Location */}
      <Form.Group className={`mb-4 ${errors.qrph_door_hanger_location ? 'form-group-error' : ''}`}>
        <Form.Label className="fw-bold">
          QRPH door hanger location <span className="text-danger">*</span>
        </Form.Label>
        <div className="form-radio-group">
          {["glass door - eye level", "glass door - not eye level", "counter", "glass window", "others"].map((opt, idx) => (
            <div
              key={`qrph-location-${idx}-${opt}`}
              className={`form-radio-item${qrph_door_hanger_location === opt ? " selected" : ""}`}
            >
              <div className="form-radio-flex">
                <Form.Check
                  type="radio"
                  name="qrph_door_hanger_location"
                  value={opt}
                  label={opt}
                  checked={qrph_door_hanger_location === opt}
                  onChange={(e) => setLocation(e.target.value)}
                  className="form-radio"
                />
              </div>
            </div>
          ))}
        </div>
        {errors.qrph_door_hanger_location && (<div className="form-error">Required</div>)}
      </Form.Group>

      {/* Branding */}
      <Form.Group className={`mb-4 ${errors.qrph_door_hanger_brand ? 'form-group-error' : ''}`}>
        <Form.Label className="fw-bold">
          QRPH door hanger branding <span className="text-danger">*</span>
        </Form.Label>
        <div className="form-radio-group">
          <div className={`form-radio-item${qrph_door_hanger_brand === "3" ? " selected" : ""}`}>
            <div className="form-radio-flex">
              <Form.Check
                type="radio"
                name="qrph_door_hanger_brand"
                value="3"
                label="3"
                checked={qrph_door_hanger_brand === "3"}
                onChange={(e) => setBranding(e.target.value)}
                className="form-radio"
              />
            </div>
          </div>
          {/* <Image
            src="https://via.placeholder.com/150"
            alt="Branding Example"
            style={{ display: "block", margin: "10px 0", maxWidth: "150px" }}
          /> */}
          {["2.0", "1.5", "old design - green bird", "custom", "P2P"].map((opt, idx) => (
            <div
              key={`qrph-brand-${idx}-${opt}`}
              className={`form-radio-item${qrph_door_hanger_brand === opt ? " selected" : ""}`}
            >
              <div className="form-radio-flex">
                <Form.Check
                  type="radio"
                  name="qrph_door_hanger_brand"
                  value={opt}
                  label={opt}
                  checked={qrph_door_hanger_brand === opt}
                  onChange={(e) => setBranding(e.target.value)}
                  className="form-radio"
                />
              </div>
            </div>
          ))}
        </div>
        {errors.qrph_door_hanger_location && (<div className="form-error">Required</div>)}
      </Form.Group>

      {/* Count */}
      <Form.Group className={`mb-4 ${errors.qrph_door_hanger_count ? 'form-group-error' : ''}`}>
        <Form.Label className="fw-bold">
          QRPH door hanger count <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter count"
          value={qrph_door_hanger_count}
          onChange={(e) => setCount(e.target.value)}
          className="form-input"
        />
        {errors.qrph_door_hanger_count && (<div className="form-error">Required</div>)}
      </Form.Group>
                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back 
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default QRPHDoorHangerDetails;
